import { TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { DriverSummary } from 'src/app/demo/models/common-data-types';
import { FormatCapitalizedConstantsService } from 'src/app/demo/service/format-capitalized-constants.service';
import { Router } from '@angular/router';
import { NgxTranslateModule } from 'src/app/translate.module';
import { languages } from 'src/app/demo/constants/languages';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/demo/service/language.service';

@Component({
    selector: 'app-kyc-drivers-list',
    standalone: true,
    imports: [CommonModule, TableModule, ButtonModule, TooltipModule, NgxTranslateModule],
    templateUrl: './kyc-drivers-list.component.html',
    styleUrl: './kyc-drivers-list.component.scss',
})
export class KycDriversListComponent {
    @Input() drivers!: DriverSummary[];
    @Input() customerId!: string;

    languages: any[] = languages;
    selectedLanguage!: string;

    constructor(
        private formatService: FormatCapitalizedConstantsService,
        private router: Router,
        private translateService: TranslateService,
        private languageService: LanguageService
    ) { }

    ngOnInit(){
        this.initializeLocale();
        this.setLanguage(this.languageService.getLanguage());
    }

    formatText(value: string): string {
        return this.formatService.formatConstantToNormalText(value);
    }

    viewDriverClicked(id: string) {
        this.router.navigate([
            '/home/customers/' + this.customerId + '/drivers/' + id,
        ]);
    }

    initializeLocale() {
        this.languageService.currentLanguage$.subscribe((language) => {
            this.selectedLanguage = language;
            this.setLanguage(this.selectedLanguage);
        });
    }

    setLanguage(language: string) {
        this.translateService.use(language);
        this.languageService.setLanguage(language);
    }
}
